import { resolveLogoUrl, resolvePhotoUrl } from './mediaCreatorHtmlResolve';
import { buildRenderDocument, MC_HTML_LAYOUT_CSS } from './mediaCreatorRenderDocument';

export { MC_HTML_LAYOUT_CSS };

function safeFileName(title) {
  return (title || 'media_creator').replace(/[^\w\-]+/g, '_').slice(0, 80);
}

function debugComment(layout, assetUrls) {
  const payload = {
    render_mode: layout?.render_mode,
    preset: layout?.preset,
    size_px: layout?.size_px,
    logo_binding: layout?.logo_binding ?? null,
    photo_bindings: layout?.photo_bindings || {},
    photo_slots: layout?.photo_slots || [],
    resolved_logo_url: resolveLogoUrl(layout?.logo_binding, assetUrls),
    resolved_photos: Object.fromEntries(
      Object.entries(layout?.photo_bindings || {}).map(([slot, id]) => [
        slot,
        { media_asset_id: id, url: resolvePhotoUrl(id, assetUrls) },
      ]),
    ),
    note: 'Brand Library image URLs are SAS links; they may expire or require network access.',
  };
  const json = JSON.stringify(payload, null, 2).replace(/--/g, '- -');
  return `<!-- Media Creator export ${new Date().toISOString()}\n${json}\n-->`;
}

/**
 * Full HTML document (same render document as fullscreen preview and PNG export, with SAS URLs).
 */
export function buildStandaloneHtmlDocument({ layout, assetUrls, title }) {
  return buildRenderDocument(layout, {
    assetUrls,
    title,
    headExtra: debugComment(layout, assetUrls),
  });
}

export function downloadMediaCreatorHtml({ layout, assetUrls, title }) {
  const html = buildStandaloneHtmlDocument({ layout, assetUrls, title });
  const blob = new Blob([html], { type: 'text/html;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `${safeFileName(title || layout?.title)}.html`;
  link.click();
  URL.revokeObjectURL(url);
}
